import type { AutomationRule } from "../types";
import { AutomationJobList } from "./AutomationJobList";
import { AutomationRuleCreate } from "./AutomationRuleCreate";
import { AutomationRuleEdit } from "./AutomationRuleEdit";
import { AutomationRuleList } from "./AutomationRuleList";

/** The Outbox — automation_jobs is the money-safety queue. */
export const automationJobs = {
  list: AutomationJobList,
  options: { label: "Automations" },
};

export const automationRules = {
  list: AutomationRuleList,
  create: AutomationRuleCreate,
  edit: AutomationRuleEdit,
  recordRepresentation: (record: AutomationRule) => record?.name,
  options: { label: "Automation rules" },
};
